import React, { useEffect, useState } from "react";
import { Modal, Button, DatePicker, TimePicker } from "rsuite";
import "./DateTimeEditModal.scss";
import {DateTimeEditModalProps} from "../modals.model";
import moment from "moment-timezone";

const DateTimeEditModal = ({
  open,
  onClose,
  initialValue,
  onSave,
  loading = false,
  title = "Редактирование"
}: DateTimeEditModalProps) => {
  const [date, setDate] = useState<Date | null>(
    initialValue ? moment(initialValue).toDate() : null
  );
  const [time, setTime] = useState<Date | null>(
    initialValue ? moment(initialValue).toDate() : null
  );

  useEffect(() => {
    if (open) {
      const init = initialValue ? moment(initialValue).toDate() : null;
      setDate(init);
      setTime(init);
    }
  }, [open, initialValue]);

  const handleSave = () => {
    if (!date || !time) {
      onClose();
      return;
    }

    const mDate = moment(date);
    const mTime = moment(time);

    const result = mDate
      .hour(mTime.hour())
      .minute(mTime.minute())
      .second(mTime.second());

    onSave(result);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="xs"
      dialogClassName="my-centered-modal"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DatePicker
          style={{ width: "100%", marginBottom: 8 }}
          format="dd.MM.yyyy"
          value={date}
          onChange={setDate}
          cleanable={false}
          disabled={loading}
        />
        <TimePicker
          style={{ width: "100%" }}
          format="HH:mm:ss"
          value={time}
          onChange={setTime}
          cleanable={false}
          disabled={loading}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" onClick={handleSave} loading={loading}>
          Сохранить
        </Button>
        <Button onClick={onClose} appearance="subtle" disabled={loading}>
          Отмена
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DateTimeEditModal;
